/* AZ & CO - arrows and drag-to-scroll for the horizontal strips.

   Both .rail and .proof-strip are real scroll containers with
   scrollbar-width:none and no controls. Touch swipes them; a mouse had no
   way through at all, so the last six bottles and everything past the fifth
   customer message were unreachable on desktop.

   The glide is a hand-rolled rAF tween rather than scrollBy({behavior}).
   Smooth scrolling is unreliable against scroll-snap-type:x, and snapping
   fights a manual tween, so snap is suspended for the tween's duration.

   v13: a page is the cells that fit with the gap after the last one counted
   in, so four cards that exactly fill the track page four at a time (the
   old sum left that gap out and paged three). Both shelves are wired: Names
   you already know (#rail) and Just landed (#drops-list). */
(function () {
  var ICON = { prev: 'M15 5l-7 7 7 7', next: 'M9 5l7 7-7 7' };

  function wire(scroller, host, navClass, cellSelector) {
    if (!scroller || !host || host.querySelector('.' + navClass)) return;

    var nav = document.createElement('div');
    nav.className = navClass;

    function button(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', label);
      b.innerHTML =
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" ' +
        'stroke="currentColor" stroke-width="1.5" stroke-linecap="round" ' +
        'stroke-linejoin="round" aria-hidden="true"><path d="' + ICON[dir] + '"/></svg>';
      nav.appendChild(b);
      return b;
    }

    var prev = button('prev', 'Previous');
    var next = button('next', 'Next');
    host.appendChild(nav);

    function maxScroll() { return scroller.scrollWidth - scroller.clientWidth; }

    function sync() {
      var over = maxScroll() > 2;
      nav.hidden = !over;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= maxScroll() - 2;
    }

    /* one page = as many whole cells as fit in the visible track */
    function step() {
      var cell = scroller.querySelector(cellSelector);
      if (!cell) return scroller.clientWidth * 0.8;
      var cs   = getComputedStyle(scroller);
      var gap  = parseFloat(cs.columnGap || cs.gap) || 0;
      var unit = cell.offsetWidth + gap;
      var room = scroller.clientWidth - 2 * (parseFloat(cs.paddingLeft) || 0);
      return Math.max(1, Math.floor((room + gap + 1) / unit)) * unit;
    }

    var raf = 0;
    function glide(to) {
      cancelAnimationFrame(raf);
      var from  = scroller.scrollLeft;
      var dest  = Math.max(0, Math.min(maxScroll(), to));
      var delta = dest - from;
      if (!delta) return;

      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        scroller.scrollLeft = dest;
        sync();
        return;
      }

      scroller.classList.add('is-glide');
      var t0 = performance.now(), dur = 480;

      (function tick(now) {
        var p = Math.min(1, (now - t0) / dur);
        scroller.scrollLeft = from + delta * (1 - Math.pow(1 - p, 3));
        if (p < 1) {
          raf = requestAnimationFrame(tick);
        } else {
          scroller.classList.remove('is-glide');
          sync();
        }
      })(t0);
    }

    prev.addEventListener('click', function () { glide(scroller.scrollLeft - step()); });
    next.addEventListener('click', function () { glide(scroller.scrollLeft + step()); });
    scroller.addEventListener('scroll', sync, { passive: true });
    addEventListener('resize', sync);
    sync();

    /* drag to scroll, mouse only - touch already swipes natively */
    var down = false, startX = 0, startLeft = 0, moved = 0;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      cancelAnimationFrame(raf);
      scroller.classList.remove('is-glide');
      down = true; moved = 0;
      startX = e.clientX; startLeft = scroller.scrollLeft;
      scroller.classList.add('is-drag');
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      scroller.scrollLeft = startLeft - dx;
      if (moved > 3) e.preventDefault();
    });

    function release() {
      if (!down) return;
      down = false;
      scroller.classList.remove('is-drag');
      sync();
    }
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
      scroller.addEventListener(t, release);
    });

    /* a drag must not fire the link or lightbox underneath it */
    scroller.addEventListener('click', function (e) {
      if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  wire(
    document.getElementById('rail'),
    document.querySelector('#stock .rail-foot'),
    'rail-nav',
    '.rail-cell'
  );

  wire(
    document.getElementById('drops-list'),
    document.querySelector('#drops .rail-foot'),
    'rail-nav',
    '.rail-cell'
  );

  wire(
    document.querySelector('.shopify-section > .proof-strip-wrap .proof-strip'),
    document.querySelector('.shopify-section > .proof-strip-wrap .proof-k'),
    'proof-nav',
    '.proof-cell'
  );
})();

/* v16 (R1). iPhone Safari only applies :active (the pressed look of a button)
   on a page that has a touchstart listener somewhere. One empty, passive one
   on the document is enough and does no work. */
document.addEventListener('touchstart', function () {}, { passive: true });
